import { useRootStore } from '~/store/root'
import { useBorrowerStore } from '~/store/borrower'
import { useProgressStore } from '~/store/progress'
import { useIdentityStore } from '~/store/identity'
import appNameFromRoute from '~/libs/app-name-from-route';
import routeAuth from '~/libs/route-authentication'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const nuxtApp = useNuxtApp()
  const { $pinia } = nuxtApp

  if (!routeAuth.isPublicRoute(to, to.query) && !useRootStore($pinia).isLoggedIn) {
    return nuxtApp.runWithContext(() => navigateTo({ path: useIdentityStore($pinia).loginUrl, query: { ...to.query, r: to.fullPath } }))
  }
})
